import React from 'react'

import turtleBankHustler from '../../images/TURTLE-BANK-HUSTLER.png'

function TurtleBankHustler() {
  return (
    <div className="Project-page container">
      <div className="row">
        <div className="col-md-6">
          <img
            src={turtleBankHustler}
            className="project-image" />
        </div>
        <div className="Project-content col-md-6">
          <h1>Turtle Bank Hustler</h1>
          <p className="Project-text">
            <strong>
            Short Film
            <br />
Weta Digital
            <br />

Director: Steve McGillen
            <br />
            2014
            <br />
            <br />

Rehearsal + On Set Acting Coach
            <br />
Coached lead actor (age 8)

            </strong>
          </p>
         
          <p className="Project-testimonial">
            "I have great belief in Ella, both as
an actress and a coach. Stuart
and I brought her on board to
chaperone our 7 year old
daughter Davida in the short film
Turtle Bank Hustler. Ella used a
number of my techniques as well
as her own to help ground
Davida's performance and keep
her secure. Ella has a natural
affinity with children and
performance and I am really
looking forward to developing this
work with her.
”
          </p>
          <h6 className="Testimonial-person">
            <strong>~Miranda Harcourt</strong>
          </h6>
        </div>
      </div>
    </div>
  )
}

export default TurtleBankHustler
